import React, { Component } from "react";
import CustomDataTableSearch from "../../../../partials/content/CustomDataTableSearch";
import { getFiscalYears } from "../../../../services/setup/finance/financeSetupService";
import withGlobalData from "../../common/withGlobalData";
class SearchFiscalYear extends Component {
  state = { reload: this.props.globalData.reload, fiscalYears: [] };

  componentDidMount() {
    this.getFiscalYears();
  }

  componentDidUpdate() {
    const { globalData } = this.props;
    const { reload } = this.state;
    if (globalData.reload !== reload) {
      this.getFiscalYears();
      this.setState({ reload: globalData.reload });
    }
  }

  async getFiscalYears() {
    const response = await getFiscalYears();
    const { data } = response.data;
    this.setState({ fiscalYears: data.fiscalYears });
  }

  render() {
    const { fiscalYears } = this.state;
    const { onSelectFiscalYear } = this.props;
    return (
      <CustomDataTableSearch
        data={fiscalYears}
        onRefreshData={() => {
          this.getFiscalYears();
        }}
        onSelectedData={(rowData, originalEvent) => {
          onSelectFiscalYear(rowData);
        }}
        columns={[
          {
            field: "select",
            body: (rowData) => (
              <React.Fragment>
                <button
                  type="button"
                  className="btn btn-label-success btn-sm btn-pill btn-bold"
                  onClick={() => onSelectFiscalYear(rowData)}
                >
                  Select <i className="fas fa-angle-double-right"></i>
                </button>
              </React.Fragment>
            ),
          },
          {
            header: "Fiscal Year ID",
            field: "ID",
            body: null,
            sortable: true,
          },
          {
            header: "Start Year",
            field: "year",
            body: null,
            sortable: true,
          },
          {
            header: "End Year",
            field: "yearTo",
            body: null,
            sortable: true,
          },
          {
            header: "Start Month",
            field: "startMonthName",
            body: null,
            sortable: true,
          },
          {
            header: "End Month",
            field: "endMonthName",
            body: null,
            sortable: true,
          },
        ]}
      />
    );
  }
}

export default withGlobalData(SearchFiscalYear);
